export const marketList = [
  {
    "market_code": "de_AQ",
    "market_name": "AQ (de)"
  },
  {
    "market_code": "en_AQ",
    "market_name": "AQ (en)"
  },
  {
    "market_code": "es_AR",
    "market_name": "AR (es)"
  },
  {
    "market_code": "de_AT",
    "market_name": "AT (de)"
  },
  {
    "market_code": "en_AU",
    "market_name": "AU (en)"
  },
  {
    "market_code": "fr_BE",
    "market_name": "BE (fr)"
  },
  {
    "market_code": "nl_BE",
    "market_name": "BE (nl)"
  },
  {
    "market_code": "pt_BR",
    "market_name": "BR (pt)"
  },
  {
    "market_code": "de_CH",
    "market_name": "CH (de)"
  },
  {
    "market_code": "it_CH",
    "market_name": "CH (it)"
  },
  {
    "market_code": "fr_CH",
    "market_name": "CH (fr)"
  },
  {
    "market_code": "cs_CZ",
    "market_name": "CZ (cs)"
  },
  {
    "market_code": "de_DE",
    "market_name": "DE (de)"
  },
  {
    "market_code": "en_DE",
    "market_name": "DE (en)"
  },
  {
    "market_code": "da_DK",
    "market_name": "DK (da)"
  },
  {
    "market_code": "en_EG",
    "market_name": "EG (en)"
  },
  {
    "market_code": "ar_EG",
    "market_name": "EG (ar)"
  },
  {
    "market_code": "es_ES",
    "market_name": "ES (es)"
  },
  {
    "market_code": "fr_FR",
    "market_name": "FR (fr)"
  },
  {
    "market_code": "en_GB",
    "market_name": "GB (en)"
  },
  {
    "market_code": "en_HK",
    "market_name": "HK (en)"
  },
  {
    "market_code": "zh_HK",
    "market_name": "HK (zh)"
  },
  {
    "market_code": "hu_HU",
    "market_name": "HU (hu)"
  },
  {
    "market_code": "en_IN",
    "market_name": "IN (en)"
  },
  {
    "market_code": "it_IT",
    "market_name": "IT (it)"
  },
  {
    "market_code": "ja_JP",
    "market_name": "JP (ja)"
  },
  {
    "market_code": "ko_KR",
    "market_name": "KR (ko)"
  },
  {
    "market_code": "de_LU",
    "market_name": "LU (de)"
  },
  {
    "market_code": "fr_LU",
    "market_name": "LU (fr)"
  },
  {
    "market_code": "es_MX",
    "market_name": "MX (es)"
  },
  {
    "market_code": "en_MY",
    "market_name": "MY (en)"
  },
  {
    "market_code": "nl_NL",
    "market_name": "NL (nl)"
  },
  {
    "market_code": "en_NZ",
    "market_name": "NZ (en)"
  },
  {
    "market_code": "pl_PL",
    "market_name": "PL (pl)"
  },
  {
    "market_code": "pt_PT",
    "market_name": "PT (pt)"
  },
  {
    "market_code": "ro_RO",
    "market_name": "RO (ro)"
  },
  {
    "market_code": "sv_SE",
    "market_name": "SE (sv)"
  },
  {
    "market_code": "en_SG",
    "market_name": "SG (en)"
  },
  {
    "market_code": "sk_SK",
    "market_name": "SK (sk)"
  },
  {
    "market_code": "en_TH",
    "market_name": "TH (en)"
  },
  {
    "market_code": "th_TH",
    "market_name": "TH (th)"
  },
  {
    "market_code": "tr_TR",
    "market_name": "TR (tr)"
  },
  {
    "market_code": "zh_TW",
    "market_name": "TW (zh)"
  },
  {
    "market_code": "en_VN",
    "market_name": "VN (en)"
  },
  {
    "market_code": "vi_VN",
    "market_name": "VN (vi)"
  },
  {
    "market_code": "en_ZA",
    "market_name": "ZA (en)"
  }
]